<template>
  <div class="page flex-col">
    <div class="group_5 flex-col">
      <div class="group_6 flex-col">
        <div class="box_2 flex-col">
          <div class="hero-banner-video">
            <div class="hero-banner-video__shade" aria-hidden="true" />
            <video
              class="hero-banner-video__media"
              :src="promoVideoSrc"
              :poster="promoPosterSrc"
              playsinline
              muted
              loop
              autoplay
              preload="metadata"
              aria-label="首页宣传视频"
            >
              您的浏览器不支持视频播放。
            </video>
            <div class="hero-banner-video__content">
              <h2 class="hero-banner-video__title">华为AI数字商场案例</h2>
              <div class="hero-banner-video__stats" role="presentation">
                <div
                  v-for="(item, index) in heroBannerStats"
                  :key="index"
                  class="hero-banner-video__stat"
                >
                  <span class="hero-banner-video__num">{{ item.num }}</span>
                  <span class="hero-banner-video__label">{{ item.label }}</span>
                </div>
              </div>
              <button
                type="button"
                class="hero-banner-video__cta"
                @click="scrollToExpertConsult"
                v-if="false"
              >
                专家咨询
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="section_6 flex-col">
        <span class="text_7">携手客户创新突破的成功案例</span>
        <div v-if="casesLoading" class="cases-hint">案例加载中…</div>
        <div class="grid_2 flex-row">
          <div
            class="list-items_1 flex-col"
            v-for="(item, index) in loopData0"
            :key="item.id != null ? `case-${item.id}` : index"
            :class="{ 'list-items_1--clickable': item.id != null }"
            role="button"
            :tabindex="item.id != null ? 0 : -1"
            @click="onCaseCardClick(item)"
            @keydown.enter.prevent="onCaseCardClick(item)"
          >
            <div class="image-text_5 flex-col justify-between">
              <div class="box_3 flex-col" :style="{ background: item.lanhuBg2 }"></div>
              <div class="text-group_7 flex-col justify-between">
                <span class="text_8">{{ item.lanhutext0 }}</span>
                <span class="text_9">{{ item.lanhutext1 }}</span>
              </div>
            </div>
            <div class="text-wrapper_1 flex-col"><span class="text_10">{{ item.lanhutext2 }}</span></div>
          </div>
        </div>
        <div class="image-text_6 flex-row justify-between">
          <span class="text-group_2">更多成功案例</span>
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngc8e1559114ee6c22858a773681b0f43d50e76a5baeacbe46394c266fcaa7a45d.png"
          />
        </div>
        <span class="text_11">精选案例集，构建共赢生态</span>
        <div class="section_11 flex-row">
          <span class="text_12">云上有为</span>
          <span class="text_13">卓越运营</span>
          <span class="text_14">云上万象中国</span>
          <div class="image-wrapper_1 flex-col">
            <img
              class="thumbnail_2"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng31a3b7716ee0d10e2ef1746e8fea6d0cb8f6089c525095d25efdffdda783ae2a.png"
            />
          </div>
          <div class="image-wrapper_2 flex-col">
            <img
              class="thumbnail_3"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng9e8a2babd37b3379da3f9c2d1606b056ec8126ca812359f040665bd8e5bc7da3.png"
            />
          </div>
        </div>
        <div class="section_8 flex-col"></div>
        <div class="section_12 flex-row justify-between">
          <div class="block_1 flex-col"><div class="group_1 flex-col"></div></div>
          <div class="block_2 flex-col">
            <div class="group_2 flex-col">
              <div class="text-group_8 flex-col justify-between">
                <span class="text_15">云上万象中国</span>
                <span class="text_16">了解华为云Stack深度用云行者最新案例</span>
              </div>
              <div class="text-wrapper_2 flex-col"><span class="text_17">查看详情</span></div>
            </div>
          </div>
          <div class="block_3 flex-col"><div class="block_4 flex-col"></div></div>
        </div>
        <div class="text-group_9 flex-col justify-between">
          <span class="text_18">开启上云之旅</span>
          <span class="text_19">全球300万客户的共同选择</span>
        </div>
        <div id="expert-consult-anchor" class="text-wrapper_3 flex-col">
          <span class="text_20">专家咨询</span>
        </div>
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng88571776a4348ab36dc18f46ccfba23936b86a2237d22405c2c5161ab8b4c5a3.png"
        />
        <SiteFooter />
      </div>
    </div>
  </div>
</template>
<script>
import { getArticleList } from '@/api/news.js';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  components: { SiteFooter },
  computed: {
    promoVideoSrc() {
      const base = process.env.BASE_URL || '/';
      return base.replace(/\/?$/, '/') + '1227-2.mp4';
    },
    promoPosterSrc() {
      return require('./assets/img/457b95ce6031488282ee261baf3bddab_mergeImage.png');
    }
  },
  data() {
    const fallbackCases = [
      {
        id: null,
        lanhuBg2:
          'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/d307827e3744425bb86ce33d98b9d5ed_mergeImage.png)',
        lanhutext0: '云南交投',
        lanhutext1: '数智通衢 彩“云”之南',
        lanhutext2: '查看详情'
      },
      {
        id: null,
        lanhuBg2:
          'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/88fe08c1e90e43d3b59c365b94a5a7ca_mergeImage.png)',
        lanhutext0: '中铝集团',
        lanhutext1: '铝行记：铝工业智能化纪录片',
        lanhutext2: '查看详情'
      },
      {
        id: null,
        lanhuBg2:
          'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/8e0321d7ad5c45f7be951a1918cf6739_mergeImage.png)',
        lanhutext0: '埃塞电信',
        lanhutext1: '从埃塞俄比亚高原到全球云端：一颗咖啡豆的数字蜕变之旅',
        lanhutext2: '查看详情'
      },
      {
        id: null,
        lanhuBg2:
          'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/5e6e54c2670444368f5e3d8da4b95e21_mergeImage.png)',
        lanhutext0: '云南交投',
        lanhutext1: '数智通衢 彩“云”之南',
        lanhutext2: '查看详情'
      },
      {
        id: null,
        lanhuBg2:
          'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/37c537816a6f40c28cc4a505ce811845_mergeImage.png)',
        lanhutext0: '中国石油西南油气田',
        lanhutext1: '云上勘探，叩问地心蓝金',
        lanhutext2: '查看详情'
      },
      {
        id: null,
        lanhuBg2:
          'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/250b5cf4d74345b0b1e789e9d8a921a0_mergeImage.png)',
        lanhutext0: '鄂尔多斯工业互联网平台',
        lanhutext1: '推动区域工业数智化转型',
        lanhutext2: '查看详情'
      }
    ];
    return {
      casesLoading: false,
      heroBannerStats: [
        { num: '170+', label: '国家与地区' },
        { num: '300万+', label: '客户选择' },
        { num: '9000+', label: '技术伙伴' }
      ],
      loopData0: fallbackCases.slice(),
      constants: {}
    };
  },
  mounted() {
    this.fetchCaseList();
  },
  methods: {
    async fetchCaseList() {
      this.casesLoading = true;
      try {
        const r = await getArticleList(1, 6);
        if (r.success && r.list && r.list.length) {
          this.loopData0 = r.list;
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.casesLoading = false;
      }
    },
    onCaseCardClick(item) {
      if (item == null || item.id == null || item.id === '') return;
      this.$router.push({
        path: '/lanhu_zixunzhongxinxiangqing',
        query: { id: String(item.id) }
      });
    },
    scrollToExpertConsult() {
      const el = document.getElementById('expert-consult-anchor');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
};
</script>
<style scoped lang="less" src="./assets/index.less" />
<style scoped lang="less">
.cases-hint {
  width: 100%;
  text-align: center;
  color: rgba(110, 110, 123, 1);
  font-size: 14px;
  margin: 8px 0 4px;
}
.list-items_1--clickable {
  cursor: pointer;
  outline: none;
}
.list-items_1--clickable:focus-visible {
  box-shadow: 0 0 0 2px rgba(7, 98, 203, 0.45);
  border-radius: 16px;
}
</style>